<div class="main-content">
  <app-header [title]="'PERSONAL_INFO.TITLE' | translate" [subtitle]="'PERSONAL_INFO.SUBTITLE' | translate" />

  <div class="row pt-5">
    <div class="col-12 mt-3">
      <app-icam-container [iconName]="'account'">
        <form [formGroup]="form" class="form-container d-flex flex-column">
          <div class="form-section profile-section w-100">
            <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
              <div class="d-flex align-items-center p-2">
                <img class="section-image" src="../../assets/icon/picture.svg" alt="picture" />
              </div>
              <div class="form-title-text-container">
                <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                  {{ 'PERSONAL_INFO_FORM.IMAGE_PROFILE' | translate }}
                </p>
              </div>
            </div>
            <div class="user-image-container" (click)="fileInput.click()" (keydown.enter)="fileInput.click()" tabindex="0">
              @if (userImage) {
                <img [src]="userImage" class="user-image rounded-circle" alt="User image" />
              } @else {
                @if (isLoadingImage) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status"></div>
                  </div>
                } @else {
                  <app-icam-icon iconName="user" iconHeight="100%" [isDefault]="true" />
                }
              }
              <div class="image-overlay rounded-circle">
                @if (userImage) {
                  <div class="overlay-content" tabindex="0" (click)="removeImage(); $event.stopPropagation()" (keydown.enter)="removeImage(); $event.stopPropagation()">
                    <i class="bi bi-trash-fill text-white"></i>
                    <span class="overlay-text">{{ 'PERSONAL_INFO_FORM.DELETE' | translate }}</span>
                  </div>
                } @else {
                  <div class="overlay-content">
                    <i class="bi bi-camera text-white"></i>
                    <span class="overlay-text">{{ 'PERSONAL_INFO_FORM.UPLOAD' | translate }}</span>
                  </div>
                }
              </div>
              <input
                type="file"
                #fileInput
                (change)="onFileSelected($event)"
                accept=".jpeg, .jpg, .png"
                style="display: none"
              />
            </div>
            <p class="image-hint">{{ 'PERSONAL_INFO_FORM.CLICK_TO_CHANGE' | translate }}</p>
            @if (imageLoadingSuccess) {
              <p class="text-success">
                {{ 'UPLOAD_SUCCESSFUL' | translate }}
              </p>
            }
            @if (imageLoadingSuccess === false) {
              <p class="text-accent-red">
                {{ 'UPLOAD_FAILURE' | translate }}
              </p>
            }
            @if (imageDeletionSuccess) {
              <p class="text-success">
                {{ 'DELETION_SUCCESSFUL' | translate }}
              </p>
            }
            @if (imageDeletionSuccess === false) {
              <p class="text-success">
                {{ 'DELETION_FAILURE' | translate }}
              </p>
            }
          </div>

          <div class="form-section personal-info-section w-100">
            <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
              <div class="d-flex align-items-center p-2">
                <img class="section-image" [src]="'../../assets/icon/user.svg'" alt="user" />
              </div>
              <div class="form-title-text-container">
                <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                  {{ 'PERSONAL_INFO_FORM.PERSONAL_INFORMATION' | translate }}
                </p>
              </div>
            </div>
            <div class="input-wrapper">
              <label for="name"> {{ 'PERSONAL_INFO_FORM.NAME' | translate }}*</label>
              <app-icam-input
                label="{{ 'PERSONAL_INFO_FORM.NAME' | translate }}"
                inputId="name"
                [isSlim]="true"
                formControlName="firstName"
                [required]="true"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>
            <div class="input-wrapper">
              <label for="last_name">{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}*</label>
              <app-icam-input
                label="{{ 'PERSONAL_INFO_FORM.LAST_NAME' | translate }}"
                inputId="last_name"
                formControlName="lastName"
                [isSlim]="true"
                [required]="true"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>
            <div class="input-wrapper">
              <label for="role">{{ 'PERSONAL_INFO_FORM.ACCOUNT_TYPOLOGY' | translate }}</label>
              <app-icam-input
                label="{{ 'PERSONAL_INFO_FORM.ACCOUNT_TYPOLOGY' | translate }}"
                inputId="role"
                [isSlim]="true"
                [required]="true"
                formControlName="role"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>

            <div class="input-wrapper">
              <label for="accountName">{{ 'PERSONAL_INFO_FORM.ACCOUNT_NAME' | translate }}</label>
              <app-icam-input
                label="{{ 'PERSONAL_INFO_FORM.ACCOUNT_NAME' | translate }}"
                inputId="accountName"
                [isSlim]="true"
                formControlName="accountName"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>
            <div class="input-wrapper">
              <label for="phone">{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}</label>
              <app-icam-input
                label="{{ 'PERSONAL_INFO_FORM.PHONE' | translate }}"
                inputId="phone"
                [isSlim]="true"
                inputType="tel"
                formControlName="phone"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>
            <div class="input-wrapper">
              <p class="required-info">*{{ 'PERSONAL_INFO_FORM.REQUIRED' | translate }}</p>
            </div>
            <div class="checkbox-container">
              <label id="infoCheckboxLabel" class="text-muted mr-2 form-check-label" for="infoCheckbox">
                {{ 'PERSONAL_INFO_FORM.EMAIL_NOTIFY' | translate }}
              </label>
              <input
                type="checkbox"
                id="infoCheckbox"
                formControlName="emailNotifications"
                class="form-check-input my-0 py-0"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
              <p class="text-muted m-0 p-0" for="infoCheckbox">{{ 'PERSONAL_INFO_FORM.DISABLED' | translate }}</p>
            </div>

            <hr />

            <div class="terms-and-conditions">
              <span id="infoChecrkboxLabel" class="text-muted">
                {{ 'PERSONAL_INFO_FORM.PRIVACY_PREFIX' | translate }}
                <span
                  class="text-link"
                  (click)="onOpenModalInfo($event)"
                  (keydown.enter)="onOpenModalInfo($event)"
                  tabindex="0"
                >
                  {{ 'PERSONAL_INFO_FORM.PRIVACY_LINK' | translate }}
                </span>
                {{ 'PERSONAL_INFO_FORM.PRIVACY_SUFFIX' | translate }}
              </span>
            </div>
          </div>

          <div class="form-section access-info-section w-100">
            <div class="d-flex align-items-center form-title" [ngClass]="isLight ? 'light' : 'dark'">
              <div class="d-flex align-items-center p-2">
                <img class="section-image" src="../../assets/icon/key.svg" alt="key" />
              </div>
              <div class="form-title-text-container">
                <p class="my-0 py-0" [ngClass]="isLight ? 'light' : 'dark'">
                  {{ 'PERSONAL_INFO_FORM.ACCESS_INFORMATION' | translate }}
                </p>
              </div>
            </div>
            <div class="input-wrapper">
              <label for="email">Email*</label>
              <app-icam-input
                label="Email"
                inputId="email"
                formControlName="email"
                [isSlim]="true"
                inputType="email"
                [required]="true"
                [ngClass]="isLight ? 'light' : 'dark'"
              />
            </div>
            <div class="input-wrapper">
              <p
                class="change-password text-end text-decoration-underline"
                (click)="onClickChangePassword()"
                (keydown.enter)="onClickChangePassword()"
                tabindex="0"
              >
                {{
                  (isPasswordFieldsOpen
                    ? 'PERSONAL_INFO_FORM.CLOSE_PASSWORD_CHANGE'
                    : 'PERSONAL_INFO_FORM.PASSWORD_CHANGE'
                  ) | translate
                }}
              </p>
              @if (isPasswordFieldsOpen) {
                <div>
                  <div class="input-wrapper">
                    <p class="password-label">
                      {{ 'PERSONAL_INFO_FORM.PASSWORD_CHANGE_LABEL' | translate }}
                    </p>
                  </div>
                  <div class="input-wrapper">
                    <app-icam-input
                      label="{{ 'CURRENT_PASSWORD' | translate }}"
                      inputId="currentPassword"
                      formControlName="currentPassword"
                      [isSlim]="true"
                      inputType="password"
                      [ngClass]="isLight ? 'light' : 'dark'"
                    >
                    </app-icam-input>
                  </div>
                  <div formGroupName="passwords">
                    <div class="input-wrapper">
                      <app-icam-input
                        label="{{ 'Nuova password' | translate }}"
                        inputId="newPassword"
                        formControlName="password"
                        [isSlim]="true"
                        inputType="password"
                        [ngClass]="isLight ? 'light' : 'dark'"
                      />
                    </div>
                    <div class="input-wrapper">
                      <app-icam-input
                        label="{{ 'CONFIRM_NEW_PASSWORD' | translate }}"
                        inputId="confirmPassword"
                        formControlName="confirmPassword"
                        [isSlim]="true"
                        inputType="password"
                        [ngClass]="isLight ? 'light' : 'dark'"
                      />
                    </div>
                  </div>
                  @if (passwordFormField?.value) {
                    <div class="text-accent-red text-sm text-start">
                      <ul>
                        <li
                          class="block"
                          [ngClass]="{
                            'text-primary': passwordFormField?.value?.match('^(?=.*[A-Z])')
                          }"
                        >
                          {{ 'NEW_PASSWORD.CRITERIA.UPPERCASE' | translate }}
                        </li>
                        <li
                          class="block"
                          [ngClass]="{
                            'text-primary': passwordFormField?.value?.match('(?=.*[a-z])')
                          }"
                        >
                          {{ 'NEW_PASSWORD.CRITERIA.LOWERCASE' | translate }}
                        </li>
                        <li
                          class="block"
                          [ngClass]="{
                            'text-primary': passwordFormField?.value?.match('(?=.*[!@#$%^&*])')
                          }"
                        >
                          {{ 'NEW_PASSWORD.CRITERIA.SPECIAL' | translate }}
                        </li>
                        <li
                          class="block"
                          [ngClass]="{
                            'text-primary': passwordFormField?.value?.match('.{8,}')
                          }"
                        >
                          {{ 'NEW_PASSWORD.CRITERIA.LENGTH' | translate }}
                        </li>
                      </ul>
                    </div>
                  }
                  @if (passwordsGroup.errors?.['PasswordNoMatch']) {
                    <div class="text-accent-red text-start">
                      {{ 'NEW_PASSWORD.NO_MATCH' | translate }}
                    </div>
                  }
                </div>
              }

              @if (isErrorChangePassword) {
                <div
                  [ngClass]="{
                    'text-accent-red': isErrorChangePassword
                  }"
                  class="text-start"
                >
                  {{ 'PASSWORD_CHANGE_ERROR' | translate }}
                </div>
              }
              @if (isErrorPassword) {
                <div
                  [ngClass]="{
                    'text-accent-red': isErrorPassword
                  }"
                  class="text-start"
                >
                  {{ 'PASSWORD_SAME_ERROR' | translate }}
                </div>
              }
              @if (isErrorChangeProfile) {
                <div
                  [ngClass]="{
                    'text-accent-red': isErrorChangeProfile
                  }"
                  class="text-start"
                >
                  {{ 'PROFILE_UPDATE_ERROR' | translate }}
                </div>
              }

              @if (isSuccessChangePassword) {
                <div
                  [ngClass]="{
                    'text-success': isSuccessChangePassword
                  }"
                  class="text-start"
                >
                  {{ 'PASSWORD_CHANGED_SUCCESS' | translate }}
                </div>
              }

              @if (isSuccessChangeProfile) {
                <div
                  [ngClass]="{
                    'text-success': isSuccessChangeProfile
                  }"
                  class="text-start"
                >
                  {{ 'PROFILE_UPDATE_SUCCESS' | translate }}
                </div>
              }

              <button
                id="button-change-password-save"
                (click)="onSubmitForm()"
                class="button-form-submit"
                [class.disabled]="disableSaveBtn || isLoadingPassword || isLoadingProfile"
                [disabled]="disableSaveBtn || isLoadingPassword || isLoadingProfile"
              >
                @if (isLoadingPassword || isLoadingProfile) {
                  <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status"></div>
                  </div>
                } @else {
                  {{ 'PERSONAL_INFO_FORM.SAVE' | translate }}
                }
              </button>
            </div>
          </div>
        </form>
      </app-icam-container>
    </div>
  </div>
</div>
<app-footer-copyright />